module.exports = __webpack_public_path__ + "img/company-four.2f55f5fd.jpg";